import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTotalBenefits } from './market-comparison.actions';
import MarketComparisonView from './market-comparison.presenter';
import { ROUTE_PATHS } from '../../app-constants';
import { startNewBusinessCase } from '../business-case/business-case.actions';

// Reducer
export const marketComparisonReducer = (state = {
  showLoader: false,
  loading: false,
  marketComparison: [],
  productRecommendation: [],
  authorableContent: null,
  graphAuthorableContent: null,
  totalBenefits: 0,
}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

// Map & Connect
export const mapStateToProps = state => ({
  productRecommendation: state.homePageReducer.productRecommendation.filter(productData => productData.recommendationSelected),
  showLoader: state.marketComparisonReducer.showLoader,
  marketComparison: state.homePageReducer.marketComparison,
  authorableContent: state.authorableContentReducer.authorableContent.marketComparison,
  graphAuthorableContent: state.authorableContentReducer.authorableContent.marketComparison.graphContent,
  totalBenefits: getTotalBenefits(state.homePageReducer.productRecommendation),
  routePaths: ROUTE_PATHS,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    startNewBusinessCase,
  }, dispatch),
});


const MarketComparison = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MarketComparisonView);

export default MarketComparison;
